import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['entries', 'row', 'template']

  addEntry () {
    this.entriesTarget.insertAdjacentHTML('beforeend', this.templateTarget.innerHTML)
    this.rowTargets.at(-1).querySelector("input[name$='[summary]']").focus()
  }

  removeEntry (event) {
    const row = event.currentTarget.closest('[data-release-notes-target="row"]')

    if (this.rowTargets.length === 1) {
      row.querySelectorAll('input').forEach((input) => { input.value = '' })
      row.querySelector('select').value = 'Feature'
      row.dataset.category = 'feature'
      return
    }

    row.remove()
  }

  categoryChanged (event) {
    event.currentTarget.closest('[data-release-notes-target="row"]').dataset.category =
      event.currentTarget.value.toLowerCase().replaceAll(' ', '-')
  }
}
